import angular from 'angular';
import moment from 'moment';
import { conversaoFormatoData } from '../../../utils/utils';
import { IAfastamento, IFeriasTrabalhador, ISituacaoFerias, ITrabalhador } from '../models/trabalhador.model';
import { IDadosModalRetornoAfastamento, IRetornosAfastamento } from '../../Meurh/Solicitacoesafastamentosretorno/models/retornoAfastamento.model';
import { TrabalhadoresService } from '../trabalhadores.service';
import { MeurhRendimentosModalService } from '../modal/rendimentos/rendimentos.modal.service';
import { ModalAjustarRetornoService } from '../components/afastamento/modalAjustarRetorno/modalAjustarRetorno.service';
import { ModalVisualizarAjustarRetornoService } from '../components/afastamento/modalVisualizarAjusteRetorno/modalVisualizarAjustarRetorno.service';
import { ModalRetornarDoAfastamentoService } from '../components/afastamento/modalRetornarDoAfastamento/modalRetornarDoAfastamento.service';
import { DocumentoColaboradorModalService } from '../../Meurh/Anexos/visualizarmodaldocumentoscolaboradores/anexos.visualizarmodal.service';
import { OcultacaoGestorService } from '../../../shared/services/ocultacao-gestor.service';

/**
 * Situações da aba Férias, derivadas das datas de gozo. A ordem é a do agrupamento na tabela.
 */
const SITUACOES_FERIAS: Record<'emGozo' | 'programadas' | 'gozadas', ISituacaoFerias> = {
    emGozo: { ordem: 0, descricao: 'Em gozo', classe: 'label-success' },
    programadas: { ordem: 1, descricao: 'Programadas', classe: 'label-primary' },
    gozadas: { ordem: 2, descricao: 'Gozadas', classe: 'label-rascunho' },
};

export class TrabalhadoresFormController implements angular.IController {
    static $inject = [
        '$scope',
        '$rootScope',
        '$stateParams',
        '$state',
        'TrabalhadoresService',
        'entity',
        'NewToaster',
        'RelatoriosService',
        '$http',
        'DocumentoColaboradorModalService',
        'MeurhRendimentosModalService',
        'ModalAjustarRetornoService',
        'ModalVisualizarAjustarRetornoService',
        'ModalRetornarDoAfastamentoService',
        'nsjRouting',
        '$q',
        '$uibModal',
        'OcultacaoGestorService'
    ];

    public dadosPrazoContrato: {
        tipoContrato?: string;
        fimContrato?: string;
        prorrogacaoContrato?: string;
        diasExperienciaInicial?: string | number;
        prorrogacaoDiasExperiencia?: string | number;
        numeroHoras?: string | number;
    } = {};

    public activeTab = 1;
    public action: string;
    public semFoto: boolean = true;
    public carregandoRelatorio: boolean = false;
    public listaDocumentosFop: Array<{ codigodocumento: string, nomedocumento: string, tenant: number }>;
    public form: angular.IFormController;

    public retornosAfastamento: IRetornosAfastamento[] = [];

    public busy = false;

    public afastamentoMaisRecente: IAfastamento | null = null;

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            nsjGlobals: any,
            liberadoTela(arg: string): boolean,
            temPermissao(permissao: string): boolean
        },
        public $stateParams: angular.ui.IStateParamsService,
        public $state: angular.ui.IStateService,
        public entityService: TrabalhadoresService,
        public entity: ITrabalhador,
        public NewToaster: any,
        public RelatoriosService: any,
        public $http: angular.IHttpService,
        public DocumentoColaboradorModalService: DocumentoColaboradorModalService,
        public RendimentosModalService: MeurhRendimentosModalService,
        public ModalAjustarRetornoService: ModalAjustarRetornoService,
        public ModalVisualizarAjustarRetornoService: ModalVisualizarAjustarRetornoService,
        public ModalRetornarDoAfastamentoService: ModalRetornarDoAfastamentoService,
        public nsjRouting: any,
        public $q: angular.IQService,
        public $uibModal: any,
        public OcultacaoGestorService: OcultacaoGestorService
    ) {
        this.action = entity.trabalhador ? 'update' : 'insert';
        this.carregaFotoTrabalhador();
        this.setActiveTab();
        this.filtrarEOrdenarFerias();

        this.RelatoriosService.listarDocumentosFop('persona.trabalhadores').then((result: Array<{ codigodocumento: string, nomedocumento: string, tenant: number }>) => {
            this.listaDocumentosFop = result;
        });

        $scope.$watch('trblhdrs_frm_cntrllr.entity', (newValue: any, oldValue: any): void => {
            if (newValue !== oldValue && this.form) {
                this.form.$setDirty();
            }
        }, true);

        this.getDadosPrazoContrato();

        if (this.funcionarioAfastado()) {
            if (this.entity.afastamentos?.length) {

                this.afastamentoMaisRecente = this.entity.afastamentos!.reduce((maisRecente, atual) => {
                    return moment(atual.data).isAfter(moment(maisRecente.data)) ? atual : maisRecente;
                }, this.entity.afastamentos![0]);
                this.getRetornosAfastamento(this.afastamentoMaisRecente.afastamentotrabalhador);
            }
        }
    }

    /**
     * Define a aba inicial a partir da querystring. Qualquer aba pedida por URL
     * é revalidada, para que uma aba ocultada por configuração ou por permissão
     * não continue acessível por deep-link.
     */
    setActiveTab() {
        const abaSolicitada = this.OcultacaoGestorService.abaPorIndex(parseInt(this.$stateParams['tab'], 10));

        this.activeTab = abaSolicitada && this.podeVerAba(abaSolicitada.slug)
            ? abaSolicitada.index
            : this.primeiraAbaVisivel();
    }

    /**
     * Combina os critérios de exibição de cada aba (tipo do colaborador,
     * liberação da tela e permissões) com as abas ocultadas por configuração
     * para usuários em modo gestor.
     */
    podeVerAba(slug: string): boolean {
        if (this.OcultacaoGestorService.abaOcultaParaGestor(slug)) {
            return false;
        }

        switch (slug) {
            case 'ferias':
            case 'vale-transporte':
                return `${this.entity.tipo}` !== '1';
            case 'arquivos':
                return this.canAccessArquivosTab();
            case 'beneficios':
                return this.$rootScope.liberadoTela('LIBERAR_VISUALIZACAO_BENEFICIO');
            default:
                return true;
        }
    }

    primeiraAbaVisivel(): number {
        const aba = this.OcultacaoGestorService.todasAsAbas().find((item) => this.podeVerAba(item.slug));

        return aba ? aba.index : 1; // dados gerais
    }

    canAccessArquivosTab(): boolean {
        return this.$rootScope.liberadoTela('LIBERAR_GED_TRABALHADOR') &&
            this.$rootScope.temPermissao('visualizar_arquivos_trabalhadores');
    }

    montaTextoGestores(): string {
        return (this.entity.gestores === null || this.entity.gestores === undefined || this.entity.gestores.length <= 0) ? 'Não possui' : this.entity.gestores.map(gestor => gestor.nome ? gestor.nome : 'Nome não informado').join(' / ');
    }

    carregaFotoTrabalhador(): void {
        if (!this.entity.trabalhador) {
            return;
        }

        this.entityService.getFotoTrabalhador(this.entity.trabalhador)
            .then((fileUrl: string): void => {
                this.semFoto = false;
                this.entity.foto_url = fileUrl;
            })
            .catch((): void => {
                this.semFoto = true;
            });
    }

    abrirModalRendimentos(): void {
        this.RendimentosModalService.open({
            rendimentos: this.entity.rendimentos!,
            total: this.entity.outrosrendimentos!
        }).result
            .then(() => {/**/ })
            .catch((error: any): void => {/**/ });
    }

    visualizarFichaCadastral(id: string): void {
        this.carregandoRelatorio = true;
        let ids: any = id !== null ? [id] : [];

        if (ids.length > 0) {
            let constructor = { 'trabalhadores': ids, 'id': 'null' };
            let callback = (): void => {
                this.carregandoRelatorio = false;
            };

            this.RelatoriosService.abrirRelatorioFop('persona_trabalhadores_ficha', constructor, callback, false);
        }
    }

    visualizarFichaCadastralResumida(id: string): void {
        this.carregandoRelatorio = true;
        let ids: any = id !== null ? [id] : [];

        if (ids.length > 0) {
            let constructor = { 'trabalhadores': ids, 'id': 'null' };
            let callback = (): void => {
                this.carregandoRelatorio = false;
            };

            this.RelatoriosService.abrirRelatorioFop('persona_trabalhadores_ficha_resumida', constructor, callback, false);
        }
    }

    visualizarRelatorioFop(id: string, estabelecimento: string, relatorio: string): void {
        this.carregandoRelatorio = true;

        let constructor = { id, estabelecimento, relatorio };
        let callback = (): void => {
            this.carregandoRelatorio = false;
        };

        this.RelatoriosService.abrirRelatorioFop('persona_trabalhadores_relatoriofop', constructor, callback, false);
    }

    visualizarDocumentoColaborador(trabalhador: string, document: any): void {
        if (document.possuibin) {
            if (document.urldocumento.includes('pdf')) {
                let callback = (): void => {
                    this.carregandoRelatorio = false;
                };

                this.RelatoriosService.abrirRelatorioFop('persona_documentoscolaboradores_download', { 'trabalhador': trabalhador, 'id': document.documentocolaborador, 'download': true }, callback, false);
            } else {
                let url = this.nsjRouting.generate('persona_documentoscolaboradores_download', { 'trabalhador': trabalhador, 'id': document.documentocolaborador }, true);

                this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
                    this.$http.get(url, { responseType: 'arraybuffer' })
                        .then((response: any): void => {
                            this.semFoto = false;

                            let mimeType = response.headers('Content-Type');
                            let file = new Blob([response.data], { type: mimeType });
                            let fileUrl = URL.createObjectURL(file);

                            let documentoAux: any = [];
                            documentoAux = angular.copy(document);

                            documentoAux.bindocumento = fileUrl;
                            documentoAux.possuibin = document.possuibin;

                            const modal = this.DocumentoColaboradorModalService.open(documentoAux);
                            modal.result.catch(() => {/* */});

                            resolve(response);
                        })
                        .catch((response: any): void => {
                            reject(response);
                        });
                });
            }
        } else {
            const modal = this.DocumentoColaboradorModalService.open(document);
            modal.result.catch(() => {/* */});
        }
    }

    baixarDocumentoColaborador(trabalhador: string, documento: any): void {
        if (documento.possuibin) {
            let url = this.nsjRouting.generate('persona_documentoscolaboradores_download', { 'trabalhador': trabalhador, 'id': documento.documentocolaborador, 'download': true }, true);

            this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
                this.$http.get(url, { responseType: 'blob' })
                    .then((response: any): void => {
                        this.handleDownload(response.data, documento.urldocumento, 'application/octet-stream');
                    })
                    .catch((response: any): void => {
                        reject(response);
                    });
            });
        } else {
            const modal = this.DocumentoColaboradorModalService.open(documento);
            modal.result.catch(() => {/* */});
        }
    }

    getVtTotal(): number {
        return this.entity.valor_vt!.reduce((prevVal: number, elem: any): number => {
            return prevVal + (elem.tarifaconcessionariavt.valor * elem.quantidade);
        }, 0);
    }

    getDataFormatada(data: string): string {
        return conversaoFormatoData(data);
    }

    calculosEmDatas(data: string, operacao: 'add' | 'sub', quantidade: number, unidadeTempo: 'days' | 'months' | 'years') {

        let dataCalculada;

        if (operacao === 'add') {
            dataCalculada = moment(data).add(quantidade, unidadeTempo).format('YYYY-MM-DD');
        } else if (operacao === 'sub') {
            dataCalculada = moment(data).subtract(quantidade, unidadeTempo).format('YYYY-MM-DD');
        }

        return dataCalculada;
    }

    public podeExibirFichaResumida(): boolean {

        const flagFichaResumida = this.$rootScope.nsjGlobals.a.habilitados.LIBERAR_FICHA_CADASTRAL_RESUMIDA;
        const permissaoFicha = this.$rootScope.temPermissao('relatorios_fichascadastrais');

        return flagFichaResumida && permissaoFicha;
    }

    public voltarParaListagem(): void {
        const returnState = this.$stateParams['returnState'];
        const returnContext = this.$stateParams['returnContext'];

        if (returnState && this.$state.get(returnState)) {
            this.$state.go(returnState, { returnContext: returnContext || null });
            return;
        }

        this.$state.go('trabalhadores');
    }

    public podeAjustarRetornoAfastamento(naoTemRetorno: boolean = false): boolean {
        const estaAfastado = this.funcionarioAfastado();
        const semDataRetorno = this.afastamentoMaisRecente?.semdataretorno;
        const temAjusteRetornoAfastamento = this.temAjusteRetornoAfastamento(this.afastamentoMaisRecente);

        return estaAfastado && !temAjusteRetornoAfastamento && (naoTemRetorno ? semDataRetorno : !semDataRetorno);
    }

    public funcionarioAfastado(): boolean {
        const statusAfastamento = ['03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15'];
        const estaAfastado = statusAfastamento.includes(this.entity.situacao.situacaofuncionario);

        return estaAfastado;
    }

    public temAjusteRetornoAfastamento(dadosAfastamento: IAfastamento | null = this.afastamentoMaisRecente): boolean {
        return !!this.getRetornoAfastamentoPorAfastamento(dadosAfastamento);
    }

    public abrirRetornarDoAfastamento() {
        const modal = this.ModalRetornarDoAfastamentoService.open(this.entity);
        modal.result
            .then((dataRetorno: string) => {
                const params = {
                    situacao: 0,
                    estabelecimento: this.entity.estabelecimento.estabelecimento,
                    trabalhador: this.entity.trabalhador,
                    dataretorno: dataRetorno,
                    afastamentotrabalhador: this.afastamentoMaisRecente.afastamentotrabalhador
                };
                this.entityService.ajustarRetorno(params)
                    .then(() => {
                        this.NewToaster.pop({
                            type: 'success',
                            title: 'A data de retorno do afastamento foi adicionada.'
                        });
                        this.$state.reload();
                    })
                    .catch(() => {
                        this.NewToaster.pop({
                            type: 'error',
                            title: 'Ocorreu um erro ao adicionar a data de retorno do afastamento.'
                        });
                    });
            })
            .catch(() => {/* */});
    }

    public abrirAjustarRetorno(): void {
        const dataRetornoOriginal: moment.Moment = moment(this.afastamentoMaisRecente.data).add(this.afastamentoMaisRecente.dias, 'd');
        const afastamento: IDadosModalRetornoAfastamento = {
            dataRetornoOriginal: dataRetornoOriginal,
            nomeColaborador: this.entity.nome,
            tipoAfastamento: this.afastamentoMaisRecente.tipohistorico.descricao
        };

        const confirm = this.ModalAjustarRetornoService.open(afastamento);

        confirm.result.then((dataAjusteRetorno: string) => {
            const params: {
                situacao: number,
                estabelecimento: string,
                trabalhador: string,
                dataretorno: string,
                afastamentotrabalhador: string
            } = {
                situacao: 0,
                estabelecimento: this.entity.estabelecimento.estabelecimento,
                trabalhador: this.entity.trabalhador,
                dataretorno: dataAjusteRetorno,
                afastamentotrabalhador: this.afastamentoMaisRecente.afastamentotrabalhador
            };

            this.entityService.ajustarRetorno(params)
                .then(() => {
                    this.NewToaster.pop({
                        type: 'success',
                        title: 'A data de retorno do afastamento foi alterada'
                    });

                    this.$state.reload();
                })
                .catch(() => {
                    this.NewToaster.pop({
                        type: 'error',
                        title: 'Ocorreu um erro ao ajustar a nova data de retorno do afastamento'
                    });
                });
        })
            .catch((error: any) => {
                if (error !== 'backdrop click' && error !== 'fechar' && error !== 'escape key press') {
                    this.NewToaster.pop({
                        type: 'error',
                        title: error
                    });
                }
            });
    }

    public visualizarAjusteRetorno(dadosAfastamento: IAfastamento): void {
        const retornoAfastamento = this.getRetornoAfastamentoPorAfastamento(dadosAfastamento);

        if (!retornoAfastamento) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Não foi possível encontrar a solicitação'
            });

            return;
        }

        const dataRetornoOriginal: moment.Moment = moment(dadosAfastamento.data).add(retornoAfastamento.afastamentotrabalhador.dias, 'd');
        const afastamento: IDadosModalRetornoAfastamento = {
            dataRetornoOriginal: dataRetornoOriginal,
            nomeColaborador: this.entity.nome,
            tipoAfastamento: dadosAfastamento.tipohistorico.descricao,
            situacao: retornoAfastamento.situacao,
            dataNovoRetorno: moment(retornoAfastamento.dataretorno)
        };

        const confirm = this.ModalVisualizarAjustarRetornoService.open(afastamento);

        confirm.result.then(() => {
            try {
                this.$state.go('meurh_solicitacoesafastamentosretorno_show', { solicitacao: retornoAfastamento.solicitacao });
            } catch {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Não foi possível encontrar a solicitação'
                });
            }
        })
            .catch((error: any) => {
                if (error !== 'backdrop click' && error !== 'fechar' && error !== 'escape key press') {
                    this.NewToaster.pop({
                        type: 'error',
                        title: error
                    });
                }
            });
    }

    public getRetornosAfastamento(afastamento: string): void {
        this.entityService.getRetornoAfastamento(afastamento)
            .then((retornosAfastamento) => {
                this.aplicarRetornosAfastamento(retornosAfastamento.data);
            })
            .catch(() => {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Ocorreu um erro ao buscar as alterações de retorno de afastamento'
                });
            });
    }

    private getRetornoAfastamentoPorAfastamento(dadosAfastamento: IAfastamento | null | undefined): IRetornosAfastamento | undefined {
        if (!dadosAfastamento) {
            return undefined;
        }

        return this.retornosAfastamento.find((retornoAfastamento) =>
            retornoAfastamento.afastamentotrabalhador.afastamentotrabalhador === dadosAfastamento.afastamentotrabalhador
        );
    }

    private aplicarRetornosAfastamento(retornosAfastamento: IRetornosAfastamento[]): void {
        this.retornosAfastamento = retornosAfastamento;

        if (!this.entity.afastamentos?.length) {
            return;
        }

        for (const retornoAfastamento of this.retornosAfastamento) {
            const afastamentoVinculado = this.entity.afastamentos.find((afastamentoAtual) =>
                afastamentoAtual.afastamentotrabalhador === retornoAfastamento.afastamentotrabalhador.afastamentotrabalhador
            );

            if (afastamentoVinculado) {
                afastamentoVinculado.dias = moment(retornoAfastamento.dataretorno).diff(moment(afastamentoVinculado.data), 'd');
            }
        }
    }

    /**
     * Define a situação de cada aviso de férias, esconde os já gozados que não foram efetivados no Persona
     * (sem cálculo nem afastamento de férias) e ordena o restante: em gozo, programadas (da mais próxima
     * para a mais distante) e gozadas (da mais recente para a mais antiga). A situação é calculada uma vez,
     * com o mesmo "hoje" para rótulo, filtro e ordem; roda antes do $watch da entity para não sujar o form.
     */
    private filtrarEOrdenarFerias(): void {
        if (!this.entity.ferias) {
            return;
        }

        const hoje: string = moment().format('YYYY-MM-DD');

        this.entity.ferias.forEach((ferias: IFeriasTrabalhador) => {
            ferias.situacaoExibicao = this.situacaoFerias(ferias, hoje);
        });

        this.entity.ferias = this.entity.ferias
            .filter((ferias: IFeriasTrabalhador) => !(ferias.efetivado === false && ferias.situacaoExibicao === SITUACOES_FERIAS.gozadas))
            .sort((a: IFeriasTrabalhador, b: IFeriasTrabalhador) => {
                if (a.situacaoExibicao !== b.situacaoExibicao) {
                    return a.situacaoExibicao!.ordem - b.situacaoExibicao!.ordem;
                }

                const comparacao: number = (a.datainiciogozo || '').localeCompare(b.datainiciogozo || '');

                return a.situacaoExibicao === SITUACOES_FERIAS.programadas ? comparacao : -comparacao;
            });
    }

    /**
     * Datas no formato YYYY-MM-DD, comparadas como texto. Aviso sem data de gozo não tem como estar
     * em andamento: sem início ele não é programado, e sem fim ele conta como gozado.
     */
    private situacaoFerias(ferias: IFeriasTrabalhador, hoje: string): ISituacaoFerias {
        if ((ferias.datainiciogozo || '') > hoje) {
            return SITUACOES_FERIAS.programadas;
        }

        return (ferias.datafimgozo || '') < hoje ? SITUACOES_FERIAS.gozadas : SITUACOES_FERIAS.emGozo;
    }

    private handleDownload(file: File, name: string, type?: string) {
        const blob = new Blob([file], { type });
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(fileURL);
    }

    private getDadosPrazoContrato(): void {
        const tipoContrato = {
            1: 'Indeterminado',
            2: 'Determinado (em dias)',
            3: 'Determinado (por fato)'
        };

        this.dadosPrazoContrato.tipoContrato = tipoContrato[this.entity.tipocontrato] || 'Não informado.';
        this.dadosPrazoContrato.fimContrato = this.entity.datafimcontrato || 'Não informado.';
        this.dadosPrazoContrato.prorrogacaoContrato = this.entity.dataprorrogacaocontrato || 'Não informado.';
        // campo oculto para gestor chega como '********' e não pode virar Number (exibiria 'NaNh')
        this.dadosPrazoContrato.numeroHoras =
            this.entity.horas !== undefined && this.entity.horas !== null
                ? (this.entity.horas === OcultacaoGestorService.MASCARA
                    ? this.entity.horas
                    : `${Number(this.entity.horas).toString()}h`)
                : 'Não informado.';
        this.dadosPrazoContrato.diasExperienciaInicial =
            this.entity.diasexperienciacontrato !== undefined && this.entity.diasexperienciacontrato !== null
                ? this.entity.diasexperienciacontrato
                : 'Não informado';
        this.dadosPrazoContrato.prorrogacaoDiasExperiencia =
            this.entity.diasprorrogacaocontrato !== undefined && this.entity.diasprorrogacaocontrato !== null
                ? this.entity.diasprorrogacaocontrato
                : 'Não informado';
    }
}
